import {
    PROMOTE_SCHEMA_REQUEST,
    PROMOTE_SCHEMA_SUCCESS,
    PROMOTE_SCHEMA_FAILURE,
    DEMOTE_SCHEMA_REQUEST,
    DEMOTE_SCHEMA_SUCCESS,
    DEMOTE_SCHEMA_FAILURE,
} from "./actions";

const initialState = {
    // In-session overrides after a promote/demote:
    // { [schemaId]: { promotionStatus, promotedVersion, promotedDate, promotedBy } }
    promotionBySchema: {},
    working: false,
    promotionResult: { success: true },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case PROMOTE_SCHEMA_REQUEST:
        case DEMOTE_SCHEMA_REQUEST:
            return { ...state, working: true };
        case PROMOTE_SCHEMA_SUCCESS:
        case DEMOTE_SCHEMA_SUCCESS: {
            const schemaModel = action.payload || {};
            return {
                ...state,
                working: false,
                promotionResult: { success: true },
                promotionBySchema: {
                    ...state.promotionBySchema,
                    [schemaModel.schemaId]: {
                        promotionStatus: schemaModel.promotionStatus,
                        promotedVersion: schemaModel.promotedVersion,
                        promotedDate: schemaModel.promotedDate,
                        promotedBy: schemaModel.promotedBy,
                    },
                },
            };
        }
        case PROMOTE_SCHEMA_FAILURE:
        case DEMOTE_SCHEMA_FAILURE:
            return { ...state, working: false, promotionResult: { success: false, ...action.payload } };
        default:
            return state;
    }
};
